import React, { useState } from "react";
import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Input,
  Row,
} from "reactstrap";
import sortArrow from "../../../../../assets/inventory/sort-arrows.svg";
import upArrow from "../../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../../assets/inventory/down-arrow.svg";

const ReceiveOrderMoreDetails = () => {
  const [increment, setIncrement] = useState(0);

  return (
    <div className="invOrderDetails p-3">
      {/* <div
        className=""
        style={{ marginBottom: "15px" }}
      ></div>
      <div> */}
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Product Name</div>
            <div className="inv-details">Lisinopril 10mg Tablet</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">NDC/UPC</div>
            <div className="inv-details">34981-3198-99</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Manufacturer</div>
            <div className="inv-details">McKessson</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Quantity Required</div>
            <div className="inv-details">3 Bottles</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Par Level</div>
            <div className="inv-details">3000 Tablets</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Quantity On Hand</div>
            <div className="inv-details">500</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Package Cost</div>
            <div className="inv-details">$ 89.50</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Unit Cost </div>
            <div className="inv-details">$ 895.000</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Drug Status</div>
            <div className="inv-details">Owed</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Allow SubTitles</div>
            <div className="inv-details">Yes</div>
          </Col>
          <Col md="4"></Col>
          <Col md="4"></Col>
        </Row>
        <div className="qty-footer">
          <Row className="bg-light p-box">
            <Col className="qty-head-text" lg={12}>
              Quantity Required <img src={sortArrow} />
            </Col>
          </Row>
            <div className="qty-count mb-2 mt-2" style={{ width: "100%"}}>
              <div>{increment}</div>
              <div className="d-flex flex-column cursor-pointer">
                <img
                  src={upArrow}
                  onClick={() => setIncrement(increment + 1)}
                />
                <img
                  src={downArrow}
                  onClick={() => setIncrement(increment - 1)}
                />
              </div>
            </div>
          </div>

     
    </div>
  );
};

export default ReceiveOrderMoreDetails;
